module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chno"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("ONE")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "chtitle"
  }, [_vm._v("BURYING THE DEAD")]), _vm._v(" "), _c('p', {
    staticClass: "chtitlea"
  }, [_c('i', [_vm._v("Cemeteries, Walls, and Jewish Identity in Early Twentieth-Century Argentina")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Jews bury themselves the way they live.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Nathan Englander, "), _c('i', [_vm._v("The Ministry of Special Cases")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("Only death requires that we be precise.")])]), _c('p', {
    staticClass: "right"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Yehuda Amichai, “The Clouds Are the First Fatalities”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_1",
      "id": "fn1_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("THERE LIES AN OLD WALLED-IN JEWISH CEMETERY IN AVEL")]), _vm._v("laneda, a suburb to the south of Buenos Aires. The tombs, still bearing sepia pictures of the deceased and blurred Yiddish inscriptions, were once adorned with expensive marble monuments; now they are almost all destroyed by the passage of time, occasional vandalism, and a wish to forget. The cemetery abuts that of the Moroccan Jewish congregation, and the differences between the two graveyards could not be starker. In contrast to the unkempt grass and damaged tombs of the walled cemetery, that of the Moroccan Jews displays carefully maintained and finely decorated monuments.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The identity of those buried in the walled cemetery holds the key to understanding this vivid contrast. They were members of the Zwi Migdal, an infamous mutual aid association of Jewish pimps and madams involved in the international traffic of Jewish women known as “white slavery.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_2",
      "id": "fn1_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The embarrassing presence of large numbers of organized Jewish pimps and prostitutes threatened the broader Jewish community’s standing within Argentine society—precisely because these outlaws insisted on identifying themselves as Jews—in early "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("twentieth-century Buenos Aires, which already had a reputation as “the capital of vice.” Shunned by the broader community, the traffickers nevertheless worked to create and sustain their own Jewish institutions, such as the cemetery, and a synagogue. The Zwi Migdal had originally requested burial space from the majority Ashkenazi community but was “informed that the separation between purity and impurity was extended even to the dead.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_3",
      "id": "fn1_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" Its members were thus forced to establish their own cemetery, outside communal boundaries. Although the small Sephardi Moroccan community eventually shared a common wall with the Zwi Migdal, even "), _c('i', [_vm._v("they")]), _vm._v(" carefully walled the cemetery off, and left to neglect the burial ground of the “impure” when the organization was dismantled by the Argentine police in 1930.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Walls went up among “pure” Jews, as well. The four main Sephardi immigrant groups, as soon as they arrived in Buenos Aires, organized burial societies, raised money, and negotiated with Argentine authorities, among themselves, and with Ashkenazim to purchase lots to bury "), _c('i', [_vm._v("their")]), _vm._v(" dead. By 1957, Sephardi societies had founded six separate cemeteries close to the city of Buenos Aires, and had opened up five burial grounds (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#fig1_1"
    }
  }, [_vm._v("figure 1.1")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/xhtml/#tab1_1"
    }
  }, [_vm._v("table 1.1")]), _vm._v("). Some of these groups shared land, but their dead lay separated by walls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Outside Buenos Aires, however, Sephardim tended to be less divided by origin when founding their cemeteries. In towns across Argentina, Sephardim usually came together to bury their dead, even sharing these cemeteries with Ashkenazim, at first. Ashkenazim would eventually open up their own burial grounds, sometimes a single wall away from Sephardim. Yet in even smaller provincial towns the Jewish community, represented by a handful of members from differing origins, Ashkenazim and Sephardim, managed to achieve unity inside one cemetery wall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The walls that Jews built around their dead are the focus of this chapter. Anthropologist Fredrik Barth argued that ethnic groups are defined by the boundaries that enclose them rather than by the “cultural stuff” encircled within. These social boundaries are, of course, not static; they are modified and validated through interaction with others, an ongoing process that makes it necessary to continually redefine the line that divides those inside from those outside. This theory places “difference” at the center, as ethnic boundaries delineate just that. In Barth’s words, the boundary “implies a recognition of limitations on shared understandings, differences in criteria for judgment of value and performance, and a restriction of interaction to sectors of assumed common understanding and mutual interest.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_4",
      "id": "fn1_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" Such difference is not likely to disappear even though ethnic groups live in constant interaction with others. “The persistence of ethnic groups in contact,” contends Barth, “implies not only criteria and signals for identification, but also a structuring of interaction which allows the persistence of cultural difference.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_5",
      "id": "fn1_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Stuart Hall likewise favors a definition of cultural identity which incorporates “difference” as constitutive of that identity."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_6",
      "id": "fn1_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" In a discussion of diasporic communities, he claims that they do share a common element, yet that essential element is also necessarily modified by what the community becomes in each diasporic context. The idea of “difference” is stressed brilliantly by Daniel Boyarin and Jonathan Boyarin: “diasporic cultural identity teaches us that cultures are not preserved by being protected from ‘mixing’ but probably can only continue to exist as a product of such mixing.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_7",
      "id": "fn1_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('div', {
    staticClass: "cap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "fig1_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/fig1_1.png"
    }
  })])]), _c('a', {
    attrs: {
      "id": "fig1_1"
    }
  }), _c('p', {
    staticClass: "figcaption"
  }, [_c('a', {
    attrs: {
      "id": "fig1_1"
    }
  }, [_c('b', [_vm._v("Figure 1.1.")]), _vm._v(" Jewish cemeteries close to Buenos Aires. For key, see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#tab1_1"
    }
  }, [_vm._v("Table 1.1")]), _vm._v(", p. 28.")])]), _vm._v(" "), _c('p', {
    staticClass: "tcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _c('a', {
    attrs: {
      "id": "tab1_1"
    }
  }, [_c('b', [_vm._v("Table 1.1. Jewish Cemeteries Close to Buenos Aires")])])]), _c('a', {
    attrs: {
      "id": "tab1_1"
    }
  }, [_c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/tab1_1.png"
    }
  })])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "tab1_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Using Barth’s and Hall’s focus on difference as central to ethnic identity, I argue that the walls around the dead built by Sephardim and Ashkenazim in Argentina show how ethnic, subethnic, and diasporic identities were understood and experienced, and how these separations were informed by local realities. In this chapter, we see that what so outraged Ashkenazi Rabbi Joseph regarding Moroccan Jews in Buenos Aires “and their ridiculous [burial] practices,” which signaled to him the need for Ashkenazim to found a separate burial ground, did not bother Ashkenazim in Vera, in the Santa Fé province, when they came to be buried among Moroccan Jews. The issues that prompted the creation of six different Sephardi cemeteries close to the city of Buenos Aires were not apt in provincial settings, in which the Jewish population overall (and Sephardim in particular) was small. Cemetery walls underscored differences between many groups: Jews (Ashkenazim and Sephardim) from non-Jews in towns with a small Jewish population; Sephardim (regardless of origin) from Ashkenazim in larger provincial cities; and Sephardim from other Sephardim around Buenos Aires. But this chapter also shows that those differences could be overcome, even if for short periods, so that Jews in Argentina, Sephardim and Ashkenazim, Moroccan, Arabic, and Ladino speakers could negotiate common walls or shared burial grounds. The boundaries around these groups were thus not marking "), _c('i', [_vm._v("essential")]), _vm._v(" differences, but delineating "), _c('i', [_vm._v("strategic")]), _vm._v(" ones; they were malleable indeed.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Scholars have studied cemeteries for a variety of reasons. Latin American historians in particular have focused on cemeteries in order to understand the contested process of secularization that wrought control of cemeteries from the church to the state after the Wars of Independence."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_8",
      "id": "fn1_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" These studies have drawn connections between new cemeteries and modern discourses on medicine and health, as secularization was embedded in the larger project of Latin American modernization. Ethnic cemeteries and ethnic societies that provided burial in city cemeteries have also been the focus of several studies."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_9",
      "id": "fn1_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" These have stressed the "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("persistence of ethnic identity in the new lands, and the role played by death in accentuating ethnic loyalties. Jewish cemeteries in particular have received much scholarly attention. In many cases, the focus of these works has been the historical recovery of Jewish presence in areas where Jews no longer live."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_10",
      "id": "fn1_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v(" My reading of Jewish/Sephardi cemeteries aims to uncover the contested nature of the walls that encircled and divided the dead, as well as the dialogues that death spurred and made possible among the living.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("THE FIRST JEWISH ARGENTINE CEMETERIES IN SANTA FÉ")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jewish cemeteries were founded in JCA colonies as they were created. The first dates from 1891, founded in the colony of Moisesville in the province of Santa Fé."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_11",
      "id": "fn1_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Like the schools, synagogues, and libraries built in the colonies, the cemeteries belonged to the JCA, and it was not until later that they were sold to each colony’s Ḥevra Kedusha (Burial Society)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_12",
      "id": "fn1_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" In any Jewish community, this organization’s main role is the preparation and care of the body for ritual interment, but besides its burial function, the Ḥevra Kedusha purchases a plot for the construction of the cemetery and then oversees its maintenance. This role usually involves dealing with secular authorities in obtaining licenses and passing inspections.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What would become the first Sephardi cemetery was founded in the city of Santa Fé in 1895. Unlike the many ethnic groups who came to the province to work the land, the Sephardim in the capital city were not colonists themselves, but rather lived off the increasing activity brought about "), _c('i', [_vm._v("by")]), _vm._v(" colonization. The population of the province exploded, as evidenced by the number of towns, which went from four in 1869 to sixty-two in 1895."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_13",
      "id": "fn1_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" It was in these small villages that Sephardim settled. In the city of Santa Fé, for example, in 1886 and 1887, a few Moroccan Jews bought permits ("), _c('i', [_vm._v("patentes")]), _vm._v(") to sell goods out of humble “stores,” which were no more than movable trays on wheels. By 1895, several Jews had managed to buy their own, more permanent shops in key locations such as the city’s commercial area and around the train station, and had founded their first institutions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_14",
      "id": "fn1_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("The cemetery was a Jewish, not exclusively Sephardi, burial ground when it opened. In fact, the first interment was the reburial of an Ashkenazi child who had died in 1892, and was probably originally buried in the municipal cemetery."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_15",
      "id": "fn1_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" The first burial was an Ashkenazi boy, as well. The only Jewish organization in town, the Ḥevra Kedusha that bought the cemetery, was founded by forty members, of whom seven were Ashkenazim."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_16",
      "id": "fn1_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" The cemetery became Sephardi in 1915, with the founding of an Ashkenazi Ḥevra Kedusha and the subsequent purchase of a plot in 1916 for their own dead.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It is unclear what prompted the Ashkenazim to invest in their own plot in this case. But Santa Fé’s Jewish cemeteries, the first in Argentina, confirm important contentions. First, that the history of Ashkenazi Jews in Argentina requires a careful look at Santa Fé, along with Entre Ríos, Buenos Aires, La Pampa, and Santiago del Estero, as these were the areas where the JCA founded their agricultural colonies. Yet the location of the first Sephardi cemetery reminds us that we should also look to the interior of the country to find the first vestiges of Sephardi life. The opening of the Sephardi cemetery on June 5, 1895, also shows that the provincial government had by then clearly recognized that religious minorities had the right to bury their dead in their own space and following their own traditions. In 1867, the province of Santa Fé had taken cemeteries away from the control of the church, and placed them under the jurisdiction of municipal governments. The city of Santa Fé, following this decree, reserved a part of the local cemetery for “Arabs, Jews, and Protestants.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_17",
      "id": "fn1_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" But in 1871, the provincial government, through another decree, made it possible for the various religious communities to have their own cemeteries rather than share space in the municipal burial grounds. Taking advantage of this provision, the small Jewish community raised the money to buy a lot adjacent to the city cemetery. These acts—the creation of a Ḥevra Kedusha, the raising of funds, the purchase of the property—are also evidence of a commitment to maintain the cemetery rather than use the existing section in the municipal cemetery. The fact that there were no recorded burials in June 1895 indicates the purchase and creation of the cemetery had not been prompted by an individual’s death or an epidemic. Jews were in Santa Fé to stay. This "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("story further suggests that (only) from 1895 to 1916, Ashkenazim and Sephardim had found ways to negotiate their differences in order to embark on a common project.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("BUENOS AIRES: FROM NO JEWISH CEMETERY TO TWO JEWISH CEMETERIES")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("Before the two Jewish cemeteries opened in the first years of the twentieth century, Jews in Buenos Aires had solved their burial needs by using the (second) Dissidents’ Cemetery,"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_18",
      "id": "fn1_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")]), _vm._v(" a term given to burial grounds not consecrated by the Catholic Church, so both Jews and Protestants were allowed to follow their own burial traditions there. This cemetery, on the outskirts of Buenos Aires at its founding, was closed in 1892, as the expanding city encroached on its borders; the remains were disinterred and relocated to burial grounds farther outside city limits. The British and German communities obtained from the city government a parcel (Disidente Section) in the recently opened Cementerio del Oeste (Western Cemetery), later to be named Cementerio de la Chacarita (Chacarita Cemetery), and Jews continued to bury their coreligionists alongside the dead of these communities until 1900 (see "), _c('a', {
    attrs: {
      "href": "#/xhtml/#tab1_2"
    }
  }, [_vm._v("table 1.2")]), _vm._v(")."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_19",
      "id": "fn1_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" But by 1898, it was clear that the British and German community section could not accommodate the growing Jewish community’s burial needs. In fact, in 1897, the German and British communities informed the Jews that no more burials could take place in the section they managed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_20",
      "id": "fn1_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" It had become clear that Jews required a society that would ultimately secure a parcel for their own community, even while the Dissidents’ Section in the Cementerio del Oeste provided temporary respite.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("Two Ḥevrei Kedusha were created as answers to this need: one Ashkenazi, the other Sephardi. In order to found the Ashkenazi Ḥevra Kedusha in 1894, differences between Western and Eastern European Jews, as well as different political ideologies, were successfully set aside."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_21",
      "id": "fn1_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" The Congregación Israelita de la República Argentina (CIRA) (Jewish Congregation of the Republic of Argentina) had, from early on, lobbied the city government for a solution to the Jewish burial question."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_22",
      "id": "fn1_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" This congregation was made up mainly of Western European Jews (from Germany, France, and Britain), although there were a few Moroccan members."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_23",
      "id": "fn1_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" The other group interested in participating in the purchase of a cemetery parcel was the Poale Zedek (Sociedad Obrera Israelita), whose members were Russian (mostly working-class, leftist) Jews."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_24",
      "id": "fn1_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" But the Ḥevra Kedusha (formed by the coming together of members from these two groups) intended to act as an independent body, and therefore, it was agreed that the burial society should not be linked to any particular organization or congregation.")]), _vm._v(" "), _c('p', {
    staticClass: "tcaption"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "id": "tab1_2"
    }
  }, [_c('b', [_vm._v("Table 1.2. Jewish Burial Spaces in Buenos Aires")])])]), _c('a', {
    attrs: {
      "id": "tab1_2"
    }
  }, [_c('table', {
    staticClass: "topbot",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "33%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "34%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "33%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "borb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Name")])])]), _vm._v(" "), _c('td', {
    staticClass: "borb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Dates of Jewish Burials")])])]), _vm._v(" "), _c('td', {
    staticClass: "borb",
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tab"
  }, [_c('i', [_vm._v("Notes")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Second Dissidents’ Cemetery")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("1833 to 1892")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Dates cemetery was in operation.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Western Cemetery (Chacarita): Dissidents’ Section")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("1892 to 1900")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Jews were assigned to their own section: 6.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Flores")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("1900 to 1935 (with very few burials after 1910, when Liniers Cemetery opened)")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("About 887 Jews were buried here; some were transferred to Liniers Cemetery when it opened.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Jewish Cemetery in Punta Alta")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("None")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tabh"
  }, [_vm._v("Approved by the city in 1925, but permits were revoked in 1926, before the cemetery opened.")])])])])])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "tab1_2"
    }
  }, [_vm._v("The decision to form alliances in order to build a cemetery was fundamentally a financial one. The construction of synagogues (and sometimes even the rental of a room to hold services for the High Holidays) was made difficult by the shortage of cash, so finding the necessary resources to buy and upkeep cemeteries was extremely challenging. Small congregations or societies would find it very difficult to finance this project on their own. Religious, secular, Zionist, Bundist, Communist, and even Jews who married out of the faith, all came together around Jewish burial and a Jewish cemetery."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_25",
      "id": "fn1_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Guemilut Ḥasadim, the Moroccan community Ḥevra Kedusha, was founded in 1897. The few Moroccan Jews who were part of the mostly Ashkenazi burial society became members, as did Moroccan Jews living elsewhere in the country, some from as far as Tucumán province in northwest of Argentina."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_26",
      "id": "fn1_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" Like the Ashkenazi society, Guemilut Ḥasadim provided their membership with the right to rituals associated "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("with death (such as watching over the dead body, washing and preparing the body for interment) and to financial assistance for burial.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("Although the Ashkenazi Ḥevra Kedusha managed to obtain from the German and British an extension that allowed them to continue using the Dissidents’ Section until 1900, the need for a Jewish cemetery became more pressing as time went by. In 1898, the now all-Ashkenazi Ḥevra Kedusha invited the recently formed Moroccan Guemilut Ḥasadim to their meetings to discuss a future collaboration. Guemilut Ḥasadim insisted on contributing only a quarter of the needed capital, as the Moroccan community was not as numerous as the Ashkenazi one. In addition, they demanded the freedom to charge their own members independently of the prices fixed by the Ashkenazi society."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_27",
      "id": "fn1_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" The Ḥevra Kedusha seemed ready to receive less capital from the Moroccans than they wished, but it was unwilling to let the Moroccans have control over their own members. Although conversations between the two groups continued for the rest of the year, it soon became clear that no agreement could be reached. By June 1898, the Ḥevra Kedusha suggested that individual members of the Guemilut Ḥasadim donate money toward the cemetery fund rather than the burial society. The joint venture ultimately failed, as a result of financial considerations and power struggles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Ashkenazi burial society was also approached by the "), _c('i', [_vm._v("t’meym")]), _vm._v(" (impure) while the Ḥevra Kedusha and the Moroccan burial society were still negotiating. The t’meym was a group of Jewish men and women involved in the white slave trade who had brought this activity from Eastern Europe and was taking advantage of the gender imbalance created by the migratory patterns."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_28",
      "id": "fn1_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Although Jewish prostitutes were a minority within this activity (between 29.9 percent and 33.3 percent of the total number of registered prostitutes from 1899 to 1924 were Jewish), their presence, as well as the existence of Jewish pimps, embarrassed the nascent Jewish community."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_29",
      "id": "fn1_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" As much as possible, the “pure” Jewish community tried to avoid the infiltration of “impure” elements into their organizations; they implemented strict controls for membership, sometimes even rejecting donations if it was not clear who had contributed the monies."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_30",
      "id": "fn1_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Such restrictions “forced” these Jews to set up their own societies, which included, among others, a temple, a burial society, and a self-help organization. The Sociedad Israelita de Socorros Mutuos "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Varsovia (Jewish Mutual Aid Society Warsaw), founded by the t’meym in 1906—likely linked to a previous organization in existence since the 1880s—helped support the widows and orphans of members, paid for some form of health insurance, owned a mansion on Córdoba Street, and provided burial services."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_31",
      "id": "fn1_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")]), _vm._v(" According to the Ashkenazi Ḥevra Kedusha, the t’meym offered an “important sum of money” to participate in purchasing land to be used as a Jewish cemetery, stressing that they did not wish to be accepted as members. The story, according to the Ḥevra Kedusha, is that the money was rejected and these two groups went their own separate ways—a telling that is borne out in that there is no joint cemetery in existence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the Ashkenazi Ḥevra Kedusha continued searching alone for land on which to build their cemetery, the Guemilut Ḥasadim managed to purchase a plot in Barracas del Sud (present-day Avellaneda). At that time, Barracas al Sud was a small town in the province of Buenos Aires, just across the river from the city. The cemetery, located next to the municipal burial ground, opened in 1900."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_32",
      "id": "fn1_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" Today, this cemetery shares a wall that once also belonged to the “impure” Zwi Migdal."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_33",
      "id": "fn1_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Although contemporaries claimed that the Moroccan and the “impure” pooled their resources in order to buy the land from the municipal authorities,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_34",
      "id": "fn1_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" the Moroccans insist even today that they had nothing to do with the “unwanted” community."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_35",
      "id": "fn1_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" Evidence strongly supports this contention: the two cemeteries were purchased by two different associations, years apart: Guemilut Ḥasadim (1900) and Sociedad Israelita de Socorros Mutuos Ashquenasi de Barracas al Sud y Buenos Aires (1909)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_36",
      "id": "fn1_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Because these parcels were located across from Barracas al Sud’s municipal cemetery, it is likely they were chosen because of their location in a cemetery-approved zone. No permissions to open burial grounds could have been granted otherwise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the opening of the new century, then, Moroccan and “impure” Jews had their own cemeteries, and Ashkenazim continued their search for their own land. In 1930, the Zwi Migdal was declared illegal, its properties were confiscated, and its members prosecuted and sentenced to prison. The fate of the cemetery remained in a legal limbo until the late 1980s, when the municipal government made the Moroccan community responsible for its upkeep. Behind the high wall, the abandoned tombs "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("and monuments, so close to the “pure” Jews, continue to be a reminder that divisions among living Jews were also reflected in and enacted among the dead.")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("THE ASHKENAZI ḤEVRA KEDUSHA: FROM BURIAL SOCIETY TO SINGLE ASHKENAZI ORGANIZATION (KEHILA)")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("In 1910, the Ashkenazi Ḥevra Kedusha was finally able to purchase its own cemetery in Liniers, just outside the Buenos Aires city limits. Until then, it had obtained permission from Argentine authorities to bury its members in the Flores Cemetery, another cemetery on unconsecrated land (see ")]), _c('a', {
    attrs: {
      "href": "#/xhtml/#tab1_2"
    }
  }, [_vm._v("table 1.2")]), _vm._v(")."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_37",
      "id": "fn1_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" But it soon became clear that even the newly purchased cemetery in Liniers would not be able to accommodate the growing number of Jewish people living (and dying) in Buenos Aires. The burial society then negotiated with the municipal authorities to acquire a new plot of land in Punta Alta close to the Cementerio del Oeste, within city limits. The request was rejected at first, yet after an appeal to the municipal council, Buenos Aires city authorities granted the permit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_38",
      "id": "fn1_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" The Ḥevra Kedusha bought the property and began construction of a fence and an administrative building. When the buildings were finished,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_39",
      "id": "fn1_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" in December 1925, the Ḥevra Kedusha requested final permission to open the cemetery, which was granted by the council."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_40",
      "id": "fn1_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1926, however, the municipal council withdrew its permission. On April 23 and May 11, the council signed resolutions retroactively applying a law passed in December 1925—as the Ḥevra Kedusha were finishing construction—stating that “no private cemeteries and burial grounds can be built within city limits.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_41",
      "id": "fn1_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" The Ḥevra Kedusha was forced to temporarily address the problem by purchasing more land to enlarge the Liniers cemetery, in 1928, and again in 1929, it bought a section in the cemetery owned by the Aleppo Jewish community in Ciudadela, in the province of Buenos Aires. Thus the cemetery had become a key pawn in a political struggle on which the future role of the Ḥevra Kedusha rested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By 1930 there was a growing concern about the need to centralize Jewish (Ashkenazi) communal life. “Let me tell you,” the secretary of the organization informed a journalist from "), _c('i', [_vm._v("Mundo Israelita")]), _vm._v(", “that if the "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Ḥevra Kedusha is left without a cemetery, or if we have to move it outside of the city, this powerful institution will suffer.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_42",
      "id": "fn1_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" At stake was whether the Ashkenazi Ḥevra Kedusha could become the principal Jewish (Ashkenazi) organization if a full-size cemetery (ideally within city limits) was not secured for the community. A single and strong organization was necessary to, first, accomplish many of the tasks that were fulfilled by myriad small societies and, second, represent the (Ashkenazi) community to the Argentine government and to the rest of the world."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_43",
      "id": "fn1_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Several attempts had been made in the past—the Federación Israelita Argentina (Argentine Jewish Federation), formed around the need to control ritual butchering (1908–1909); the Federación Israelita (Jewish Federation) (1913–1914); and the Alianza (1920s)"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_44",
      "id": "fn1_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v("—all of which had failed. A central organization was not viable precisely because of the internal ideological, religious, and ethnic fractures that existed among Jews. Some argued it would be easier and less problematic to change an existing organization into the Jewish Kehila of Argentina, and the Ḥevra Kedusha appeared ideal. Not only did this organization have a long history of activity but it had demonstrated that it could neutralize internal divisions around ritual and burial. Further, the supporters of this measure insisted, the Ḥevra Kedusha was already in charge of two of the most important activities of a Kehila: charity and education."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_45",
      "id": "fn1_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" In 1931, some of the burial society’s board members presented a revised constitution to the governing body suggesting that the organization “formalize the activities that the Ḥevra Kedusha in fact already performs, and that are not included in its present constitution, that is to say, to represent legally all the Jews, thus preventing that anyone speak in their name, and to intensify and practice systematically social welfare and Jewish instruction.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_46",
      "id": "fn1_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" The burial society seemed poised to become the first (Ashkenazi) institution able to recruit most, if not all (Ashkenazi) Jews living there.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("But in order to succeed, the Ḥevra Kedusha of Buenos Aires needed to be the only such society among Ashkenazim. Thus the cemetery was important symbolically; it carried the potential to secure the preeminence of Ḥevra Kedusha, to make it the central institution within the community. As Leon Horischink, its secretary, aptly put it:")]), _vm._v(" "), _c('p', {
    staticClass: "quote"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("I cannot emphasize enough the importance it [the cemetery] has for the very existence of the Ḥevra Kedusha: most of its members only belong to this organization because of the cemetery…. All those who belong to the Ḥevra Kedusha envision a future that includes many other responsibilities within the community … yet this will only be achieved if the Ḥevra Kedusha continues to administer the cemetery."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_47",
      "id": "fn1_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The insistence on Buenos Aires as the location for the future cemetery was deliberate. As the society’s secretary pointed out when the city refused permission to open the Jewish cemetery in Punta Alta, “this [the rejection] was not only unjust, but we are also being humiliated as a "), _c('i', [_vm._v("colectividad")]), _vm._v(" [community] because others who belong to [other] religions or dissident sects, already have their own [cemeteries within city limits].”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_48",
      "id": "fn1_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" The Jewish community wanted to be treated the same as other religious communities, and if indeed the Ḥevra Kedusha wanted to act as spokesperson for the whole (Ashkenazi) Jewish community, it had to be able to provide the cemetery and defend the community’s position vis-à-vis the other immigrant groups.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cemetery within city limits, as explained, never materialized, but the monopoly over Ashkenazi death and burial remained in the hands of the Ḥevra Kedusha, which later changed its name to Asociación Mutual Israelita Argentina (AMIA) (Argentine Jewish Mutual Aid Association) to better reflect its objectives. In 1935, it finally bought a significant parcel of land from a Sephardi organization in La Tablada, a town in the province of Buenos Aires, and in 1957 it purchased its last parcel, in the town of Berazategui in the same province."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_49",
      "id": "fn1_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" By 1960, then, fifty years after the purchase of the first cemetery in Liniers, the Ashkenazi community could bury their members in Liniers, Ciudadela (in the section bought from the Aleppine Jews), La Tablada (which was later enlarged to meet the growing need for space), and Berazategui. These cemeteries assured the association the ability to provide burial plots for all its members.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Thus the Ashkenazi Ḥevra Kedusha traveled a long way: from a handful of men belonging mainly to the CIRA, whose main responsibility was to assure Jewish ritual burial in Protestant and municipal cemeteries, to an organized body in charge of the purchase of a parcel to be used exclusively by Jews; from managing a section of Dissidents’ Cemeteries "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("to owning four; from Ashkenazi and Sephardi to only Ashkenazi; from an Ashkenazi burial society to an (Ashkenazi) Kehila. Other Jewish Ashkenazi organizations gathered around class, ideological, religious, and political lines, but the importance of Jewish burial meant that the Ḥevra Kedusha could blur those divisions and represent the interests of all."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_50",
      "id": "fn1_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("OTHER SEPHARDI CEMETERIES IN BUENOS AIRES: BUILDING WALLS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Like the Ashkenazi Ḥevra Kedusha, Sephardi burial societies and the cemeteries they purchased and managed became centralizing institutions within their communities. Although each Sephardi group established various philanthropic, educational, and religious societies, there tended to be only one Ḥevra Kedusha and only one cemetery. Here, I briefly outline the histories of the creation of these organizations as well as their cemeteries, which bear many similarities. In most cases, burial societies became priorities very early on in the institutional history of different migratory groups; the purchase of cemeteries tended to centralize institutional life, as all societies (social, religious, educational) contributed financially, and (most) Jews belonged to them; in many cases, the power of burial societies was challenged by other groups precisely because of the power they held.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Challenges to power of burial societies were common. The Moroccan Guemilut Ḥasadim’s position within the community, for example, was tested in 1905, with the creation of a new "), _c('i', [_vm._v("hermandad")]), _vm._v(" (brotherhood): Ḥesed VeEmet. In return for the payment of a monthly fee, members were eligible for, among other things, burial services."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_51",
      "id": "fn1_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Then from 1905 to 1920, the societies worked alongside each other, burying their own members in the Moroccan cemetery. But in 1920, the leadership of these organizations decided that Guemilut Ḥasadim would be the sole organization in charge of burials (ritual and costs) and Ḥesed VeEmet would focus on philanthropy among the Moroccan community."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_52",
      "id": "fn1_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1913, Damascene Jews founded the burial society Bene Emet in Lanús, in the province of Buenos Aires. Members announced the purchase of a parcel of land in Lomas de Zamora (in the same province) to "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("be used for their cemetery, for which they paid cash, suggesting that they may have been actively raising money for some time. The cemetery opened in 1915 after meeting municipal requirements and receiving official permission. Although primarily a burial society, Bene Emet also aided members of the community. In turn, money to support the work of the organization (mainly the purchase and upkeep of the cemetery) was provided not only by the fees paid by members of the society but by collections carried out in other Arab-Jewish organizations founded by Jews from Damascus. For cemetery construction, for example, Bene Emet received donations from various Damascene congregations in La Boca and Lanús."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_53",
      "id": "fn1_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other Arab-Jewish community from the city of Aleppo founded their own Ḥevra Kedusha in 1923, which they named Ḥesed Shel Emet Sefaradit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_54",
      "id": "fn1_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" Until then, the organization buried its members in the Liniers cemetery, through agreement with the Ashkenazi Ḥevra Kedusha. The arrangement worked well for some time; however, as they announced in 1927, “[our own] cemetery would fill a major need in our community.” The parcel they managed to procure was indeed large, and they were able to sell parts of it to the Ashkenazi Ḥevra Kedusha,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_55",
      "id": "fn1_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" and to the Ladino-speaking community, whose burial needs had not yet been resolved."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_56",
      "id": "fn1_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" These sections were walled off and independent from each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1916, the Ladino-speaking community founded their Ḥevra Kedusha (Ḥesed Shel Emet). In 1919, however, this organization joined the efforts of Kahal Kadosh (later Asociación Comunidad Israelita Sefaradí de Buenos Aires; ACISBA) to raise money to buy their own synagogue, which opened in 1919. Until 1951, when they finally purchased their own cemetery (in Bancalari, province of Buenos Aires), the community met their burial needs by joining the Ashkenazim in Liniers and by purchasing a small parcel together with the Aleppine community in their Ciudadela cemetery.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was another group of Ladino-speaking Jews, those who had originally settled in the downtown area of Buenos Aires, who placed the purchase of a cemetery plot at the top of their communal objectives. In 1929, the Jews who belonged to congregation Etz HaḤaim and the El Socorro philanthropic group joined the Ladino speakers who had settled "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("in Villa Urquiza (a northern neighborhood in the city) to form the Asociación Hebrea Argentina de Socorros Mutuos (AHASM) (Argentine Jewish Mutual Aid Association). It was this new society that, in 1930, managed to purchase a parcel of land in La Tablada to create the first Ladino-speaking community cemetery, although only those belonging to the AHASM could be buried there. The purchase of the land has become a central part of this community’s institutional memory: It is seen as, first, a victory over the “shortsightedness” of the other Ladino-speaking group, which had purchased a parcel that was not big enough to meet its burial needs, and, second, as a source of pride because of the large size of the parcel purchased. Part of the land was sold to the Ashkenazi Ḥevra Kedusha, solving that organization’s needs.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("As recounted by a former president and secretary of AHASM, the story of the purchase of the La Tablada land is simple: the friendship between Alejandro Arruguete, the son of one of the past presidents of the association, and Manuel Fresco, the son of the governor of the province of Buenos Aires, resulted in the largest concession of land given to any Jewish institution. The narrative stresses that Arruguete placed the objectives of the community above all else by suggesting that his friend’s father solve the issue of Jewish burial. Fresco, according to the narrative, responded to the request by having President Uriburu (who had just come to power after the military coup) sign a degree granting a vast parcel of land in Tablada, province of Buenos Aires."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_57",
      "id": "fn1_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")]), _vm._v(" The parcel was so large (and expensive) that AHASM approached the other Ladino-speaking community, asking them to share the cost of the purchase, but the invitation was rejected. Then, as the story goes, they approached the Ashkenazi Ḥevra Kedusha, who gave AHASM the money needed to seal the deal. The story for AHASM, in the end, highlighted the fact that it was thanks to the "), _c('i', [_vm._v("criterio buenísimo de muchacho judío")]), _vm._v(" (wonderful common sense of a Jewish boy) that the burial needs not only of their society, but also of the larger (Ashkenazi) Jewish community, were finally met and solved."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_58",
      "id": "fn1_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" Ownership of a large parcel that solved burial needs for many years to come became evidence of financial solvency and independence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other Sephardi groups, much smaller in size, decided from early on not to invest in their own cemeteries and joined other Sephardi groups "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("for their burial needs. Italian and Yugoslav Sephardim, alongside Jews from Rhodes and Salonika, worked with the Ladino-speaking community that purchased the Bancalari cemetery in the early 1950s. The Jews originally from Jerusalem joined in the Aleppo community for their burial needs.")])]), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_c('p', {
    staticClass: "h1"
  }, [_vm._v("BRIDGING WALLS")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The recounting of the cemeteries and burial societies obscures the many conversations that took place between and among these groups in their search for a solution to burial needs. Some of these attempts at working together ended up in agreement, if only temporarily, while others failed almost immediately. In some cases, initial refusal turned into later acceptance; in others, agreement meant only that difference and distance was legitimized. Ultimately, paying attention to these conversations, to the bridges and walls built by Jews among and around cemeteries, highlights the contingent nature of the boundaries that defined and constituted the identity of these subethnic groups in the new land.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("The Ashkenazi Ḥevra Kedusha agreed to bury Sephardim in the lots they had secured, but not without conflict. Rodolfo Ornstein, past vice president of the Congregación Israelita de la República Argentina and the president of the Ḥevra Kedusha in 1895, protested that members of the Congregación Israelita Latina de Buenos Aires (Spanish Jewish Congregation of Buenos Aires), (Moroccan Jews) “demand that the … [burial society] pay for nurses for their sick, something which is against our constitution … and likewise demand that the "), _c('i', [_vm._v("shomrim")]), _vm._v(" [the attendant of the burial society] be obligated in some cases to watch the dead for two nights for the same price [as one].”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_59",
      "id": "fn1_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")]), _vm._v(" Ashkenazi leaders also complained that Sephardi traditions were too “different” and othered all Jews in the eyes of the broader Buenos Aires community, thus bringing unwanted attention from the city’s non-Jewish majority. For example, Rabbi Joseph, the head of the Ashkenazi burial society and rabbi of the Congregación Israelita de Buenos Aires, complained that when they bury a coreligionist, “the members of the Congregación Israelita Latina … hold ridiculous ceremonies in public that attract the attention of the populace, and could provoke a conflict with the [general] population and authorities.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_60",
      "id": "fn1_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("Although there is no clear explanation of what constituted a “ridiculous ceremony” for the Ashkenazim, Moroccan Jews (as well as other Sephardi groups) practiced some unmistakably non-European rituals, including the famous loud ululations made by mourners at the grave and the practice of burial without coffins (which were burned at the cemetery)."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_61",
      "id": "fn1_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" The Ashkenazi community and their “modern” Jewish leaders, in their wish to foster a “modern” Jewish identity in Buenos Aires, might have viewed these burial rites as “intolerably other.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_62",
      "id": "fn1_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" This attitude helps us understand why they declined to work with the Moroccan Guemilut Ḥasadim to purchase a shared lot.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Yet this initial objection to Sephardi practices and rituals did not prevent the Ashkenazi Ḥevra Kedusha from striking agreements with other Sephardi communities, probably as a result of its realization of the power (and income) such a position would generate. Until the opening of their own cemeteries, all Sephardim (with the exception of the Moroccans, who already had purchased theirs) were buried in the Ashkenazi plots of Liniers, and the section managed in the Flores municipal cemetery. Bene Emet, for example, paid the Ashkenazi Ḥevra Kedusha for the burial of several members who were laid to rest in Liniers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_63",
      "id": "fn1_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" But the relationship between these various institutions and the Ashkenazim was not devoid of conflict, nor was it always over the ritual itself. The problem was financial; it was over what prices to charge for burial, and whether favorable payment terms for those with little or no means could be obtained. The Aleppine community leaders knew that the rich had no problem negotiating with Ashkenazim. “But the poor,” they noted, “in their painful moments, always have to depend on the charity of other members; sometimes waiting until the money [to pay for expenses] is raised prevents a quick burial, and two or three days would pass before it is possible.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_64",
      "id": "fn1_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" The implication was that the Ashkenazi Ḥevra Kedusha did not make distinctions between poor and rich, therefore leaving the impoverished members of the Aleppine community even more vulnerable. Complaints leveled by the Ladino-speaking Ḥesed Shel Emet also ran along the same lines: “the Ashkenazi burial society, when dealing with poor Sephardim, did not treat them right.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_65",
      "id": "fn1_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" Burying their own members was a highly regarded mitzvah, but burying those who belonged to other communities seems to have been a mere financial transaction."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_66",
      "id": "fn1_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("Although these Sephardi groups used the Ashkenazi cemetery even while privately voicing their concerns, that tenuous association with the Ashkenazim made it more pressing for them to find an alternative. At the same meeting in which members of the Ḥesed Shel Emet (Ladino-speaking community) cited the difficulties of the needy, they launched a discussion of the cemetery options available to them. One group wished to continue their relationship with the Ashkenazi society, in the hope that the new proposed cemetery in Punta Alta (a much bigger parcel than Liniers) would ease tensions between the two associations; another group found a parcel in the town of Vicente Lopez, in the province of Buenos Aires, which would be completely theirs; and yet a third group wished to join the Aleppine Jews in their search for a parcel."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_67",
      "id": "fn1_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")]), _vm._v(" Eventually, the joint venture with the Jews from Aleppo was deemed the most financially advantageous. It solved the community’s burial problems until 1951, when they finally purchased their own separate land in the town of Bancalari.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The burial society of the Aleppine community purchased a cemetery in 1927 that opened in 1929 and was divided into three sections. One was sold to the Ladino-speaking community for their burials; another area was managed by the Ashkenazi Ḥevra Kedusha (which had by then lost the bid for the cemetery in Punta Alta); and the third area was administered by the Aleppine community’s Ḥevra Kedusha. So while these organizations were able to cooperate in the purchase of the cemetery and successfully negotiated a sharing agreement, in practice three separate cemeteries with three different burial societies only catered to their specific communities; they used the rituals they wished and provided financial support to whomever they deemed needed it. Aleppine community leaders also offered Moroccan Jews a section of the newly purchased land. The Moroccan cemetery was quickly filling up, and they had been discussing ways to obtain more space. Yet after several meetings and conversations, an agreement was not reached, so there would not be a fourth section managed by yet another Ḥevra Kedusha."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_68",
      "id": "fn1_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In 1909, the Damascene Ḥevra Kedusha (Bene Emet) approached Moroccan Sephardim about burial space in the Moroccan cemetery in Barracas al Sud, which was used by both Guemilut Ḥasadim and Ḥesed "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("VeEmet. But rather than approach the Guemilut Ḥasadim (the Moroccan Ḥevra Kedusha and the owner of the cemetery), members from the Bene Emet initiated discussions with Ḥesed VeEmet, which provided an array of philanthropic services, including burial assistance. Although Ḥesed VeEmet did not completely reject the possibility of a joint venture, the response to Bene Emet’s request was negative. Ḥesed VeEmet claimed that they wanted to accept these Syrian Jews as members, but said that the Guemilut Ḥasadim would not accept non-Moroccan dead in the cemetery they owned. The Guemilut Ḥasadim, they explained, had bought the cemetery, and decisions as to who could be buried there remained under their control. Torn between the possibility of enlarging their membership, but aware that Bene Emet’s reason for joining their mutual aid society was mainly to secure access to the cemetery for "), _c('i', [_vm._v("their")]), _vm._v(" members, Ḥesed VeEmet insisted that they would do everything in their power to obtain space for the “international” Sephardim, but guaranteed no success."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_69",
      "id": "fn1_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")]), _vm._v(" This joint project never materialized. The Damascene Ḥevra Kedusha thus set up a relationship with the Ashkenazim for burial spaces in Liniers and eventually opened their own cemetery in 1915.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reasons provided by the Moroccan Sephardim to justify the rejection of the shared burial ground illustrate the ways in which the living—their conflicts and jealousies—defined the walls built (or not) around the dead. Ḥesed VeEmet claimed that if Syrian Jews were granted rights for burial, they would end up occupying their already “reduced space,” as the number of Moroccan Jews was significantly smaller than those of the Syrian community from Damascus. But, more important, Moroccan leaders stressed that only “those international Sephardim with irreproachable behavior” could be allowed to be buried in the cemetery."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_70",
      "id": "fn1_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" Ḥesed VeEmet declared that it was not able to ascertain whether these individuals were of “irreproachable behavior,” since they did not know them while they were alive.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Such worries about behavior were not just a convenient excuse for rejecting Syrian Jews. Respectability was an important concern that Jews discussed in a variety of settings, but it is a topic that has, among scholars of Jewish Argentina, unfortunately only been framed within discussions of “prostitutes and pimps.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_71",
      "id": "fn1_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" Honor and good reputation "), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("were qualities that mattered greatly for membership in communal organizations, and an attack on one’s reputation was considered an inexcusable affront to one’s good standing in the community."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_72",
      "id": "fn1_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")]), _vm._v(" These affronts were always challenged by the “victim,” who requested that there be a public recanting of the accusation. These events were mediated by the ethnic societies to which both “victim” and “victimizer” belonged."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_73",
      "id": "fn1_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Proving “good behavior” was done through community contacts, people who vouched for one’s moral standing."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_74",
      "id": "fn1_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" Families and commercial networks usually acted in the name of individuals to provide the support required. In Argentina, such considerations continued to be important and decisive, but it became a contentious issue, especially when people of different communities of origin requested acceptance. Family and commercial ties were not common among those from different lands, so it was hard to prove “irreproachable behavior” when applicants and organizations were of different origins. Ḥesed VeEmet eventually understood that it was impossible for the Guemilut Ḥasadim to accept the request of the Syrian Jews. To be buried in their cemetery, it was required that knowledge of the dead and of the living be available, something that could not be guaranteed if the living had not shared common grounds.")]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_vm._v("SEPHARDIM AND THEIR DEAD IN THE REST OF ARGENTINA")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The story of Jewish cemeteries in the rest of Argentina shows that the borders and walls that Jews of different origins built around their dead in and around the city of Buenos Aires were not demarcating essential differences. Rather, this story stresses how identity boundaries obeyed local realities, specific to where the walls were built. This section briefly recounts the founding of the cemeteries in cities of the interior, paying specific attention to how all Sephardim, regardless of origin, found common ground to build shared institutions, and how Ashkenazim participated alongside or not in these projects. While Sephardim in these towns did not highlight the distinctions around origin they maintained in Buenos Aires, the Sephardim-Ashkenazim divide was indeed kept.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Initially, capital cities in the interior of the country had only one Jewish cemetery, and, as such, it accepted all Jews living in those towns "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("and those around it. As previously noted, the first Sephardi cemetery opened in Argentina was located in the city of Santa Fé. The next Sephardi cemetery was inaugurated in 1912, by the Ḥesed VeEmet of Resistencia, Chaco."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_75",
      "id": "fn1_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")]), _vm._v(" In 1917, the first burial in the Sephardi cemetery in the city of Corrientes took place."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_76",
      "id": "fn1_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" The location and dates of these cemeteries also show how much earlier Sephardim had been able to organize, petition, and purchase burial grounds compared with the Sephardi organizations in Buenos Aires.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Sephardi immigration to interior towns took place before the settlement of significant numbers of Ashkenazim, the Sephardi societies organized in those towns also congregated those Jews who arrived later."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_77",
      "id": "fn1_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" This was particularly true not so much for purposes of prayer but specifically for purposes of burial."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_78",
      "id": "fn1_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" For example, in Santa Fé, seven of the members of the burial society that bought the cemetery were Ashkenazim, and five of the first six dead buried in the newly acquired plots were also Ashkenazim."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_79",
      "id": "fn1_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" In Resistencia, until the creation of the Ashkenazi cemetery, there were twelve burials of members from that community in the Sephardi plot."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_80",
      "id": "fn1_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" In Corrientes, there are also around thirteen Ashkenazi members buried in the Sephardi cemetery."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_81",
      "id": "fn1_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" The cemetery (founded by mostly Sephardi members) acted, at first, as the only collective “Jewish” institution, while the other social and philanthropic organizations remained subethnically divided.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As the Ashkenazi communities grew in these cities, they eventually established their own cemeteries, but in many cases, not immediately. In Santa Fé, the Ashkenazi cemetery opened on October 1, 1916, fifteen years after the inauguration of the first cemetery."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_82",
      "id": "fn1_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" In Resistencia, the Ashkenazi community purchased their cemetery in 1938, almost twenty-six years after the Sephardim had opened theirs; in Corrientes, the Ashkenazi cemetery dates from the late 1930s, more than ten years after the opening of the first one. Because it was already possible to ensure Jewish burial in a Jewish cemetery, it seems that Ashkenazi communities opted to create other institutions before spending money on a parcel of land for their own cemeteries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the few cases in which it has been possible to document the relationship between Sephardim and Ashkenazim in the interior of the country regarding burial, it can be argued that friction, although it "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("existed, never provoked the later founding of an Ashkenazi cemetery. In 1933 in Resistencia, for example, an Ashkenazi commission requested from the Sephardi Ḥesed VeEmet the burial of one of their members. There are no records of negotiations, and the Ashkenazim paid m$n 400"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_83",
      "id": "fn1_83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")]), _vm._v(" (then about US$125) that was charged for the plot and service."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_84",
      "id": "fn1_84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" Even in the case of subsidizing the burial, which was a point of contention in Buenos Aires between the Sephardi organizations and the Ashkenazi Ḥevra Kedusha, there seems to have been a working understanding between the two groups. In January 1933, an Ashkenazi father was charged only “the minimum sum stipulated in our bylaws” (m$n 200; then about US$63) to bury his baby girl, as he was not a member of the community but “his economic situation was dire.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_85",
      "id": "fn1_85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" In October of the same year, another Ashkenazi Jew requested permission to bury his stillborn baby. The father was charged only m$n 10 (then about US$3.13) as “he does not have much money.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_86",
      "id": "fn1_86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" Unless the situation between Ashkenazim and Sephardim soured in the following five years (which is the date for the founding of the Ashkenazi cemetery), these exchanges between the two societies suggest that the groups had developed an amicable relationship; they agreed on prices and changed the costs of services depending on family need.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But while Sephardim expressed no problems with accepting Ashkenazi burials, and they even lent them other property, it was clear that matters of ownership of the cemetery would not be even discussed. In 1935, Ḥesed VeEmet in Resistencia received a letter from the president, secretary, and treasurer of the Ashkenazi community, who were asking to buy part of the cemetery for their organization’s use."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_87",
      "id": "fn1_87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" This transaction did not take place, although a few years later, Ḥesed VeEmet allowed the same organization to use their upstairs room for their religious school."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_88",
      "id": "fn1_88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other incidents recorded in the surviving minute books of the Sephardi society of Resistencia suggest that issues of ritual were also under the supervision and control of the Ḥesed VeEmet. In 1928, the executive committee of Ḥesed VeEmet decided not to accept the burial of Alfredo Shomke “as no documents or existing family can prove the dead man was indeed Jewish.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_89",
      "id": "fn1_89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" On January 1, 1930, the minutes book refers to an article in "), _c('i', [_vm._v("La Opinión")]), _vm._v(", a local newspaper, which “censured the way in "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("which Ḥesed VeEmet handled the death of a boy belonging to the Ashkenazi community.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_90",
      "id": "fn1_90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")]), _vm._v(" Although the minutes are not explicit about the issue in question—and the original article has yet to be located—it is possible to infer that it had to do with either the “Jewishness” of the boy or the manner of death.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Disagreements existed not only between Sephardim and Ashkenazim but between the Ḥesed VeEmet and Sephardi families whose members had died. In February 1933, a Sephardi Jew accused the community of not allowing the burial of his daughter. Ḥesed VeEmet requested that it be established whether the baby was stillborn, or if she had indeed been born alive, as the distinction would determine the type of burial—whether in the general section or not—required."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_91",
      "id": "fn1_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" The argument over this issue produced a rift that ended with all the executive committee resigning."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_92",
      "id": "fn1_92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])]), _vm._v(" The degree of ritual observance required by the burial society is quite surprising, and the negative response to the forcing of religious orthodoxy was quite clear, as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Santa Fé, the Ashkenazim decided to form their own Ḥevra Kedusha and raise money for their own parcel “because there is no more space in the section of the municipal cemetery reserved for dissidents.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_93",
      "id": "fn1_93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" This reason suggests that the Ashkenazi community was using the municipal cemetery for their burials, and not the already open Sephardi cemetery. Yet the number of Ashkenazim buried in this cemetery before the opening of their own contradicts the impression that tension existed between the two communities: eighty-two members, including some relatives of the founders of the Ashkenazi Ḥevra Kedusha, were laid to rest in the Sephardi cemetery. Again, this example suggests that financial and practical decisions played an important role in deciding where to be buried, not ritual or cultural matters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In other big provincial towns, the division between Ashkenazim and Sephardim was not made evident by the founding of two separate pieces of land but by a wall that divided a cemetery into two sections. This was the case in Córdoba, Salta, San Juan, and La Rioja, in which the two communities, Sephardi and Ashkenazi, pooled their resources to buy a big parcel, and then divided it according to their membership and financial capabilities. In Salta, for example, the Sephardi community bought, as early as December 1917, a plot for a cemetery."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_94",
      "id": "fn1_94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" Soon after the purchase, "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("the Sociedad Israelita Salteña “La Union” de Socorros Mutuos (Jewish Mutual Aid Society “Union” of Salta) sold part of the land to the Ashkenazi community."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_95",
      "id": "fn1_95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")]), _vm._v(" In Córdoba, the Sephardim bought a plot in 1923 and gave part to the Ashkenazi community in exchange for construction of the surrounding wall."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_96",
      "id": "fn1_96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In other (usually smaller) towns, Jews were buried together, regardless of their origin, and divided by no walls. In Catamarca, Tucumán, Formosa, San Luis, Villa Mercedes, Vera, Rosario, Posadas, and Presidencia Roque Sáenz Peña (cities with a significant number of both Sephardim and Ashkenazim), the purchase of the cemetery lot was either done by the majority Jewish organization (and the smaller group was accepted without any problems) or the cemetery was bought by an organization that was of mixed origins. In Rosario, for example, burial was always in the hands of the Ashkenazi organization even when Sephardim were indeed numerous. No evidence exists that they wanted to buy their own land."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_97",
      "id": "fn1_97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" In Roque Sáenz Peña, on the other hand, the association that bought the cemetery (and has administered it since) was made up of both Ashkenazim and Sephardim."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_98",
      "id": "fn1_98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" In Tucumán, although the cemetery belongs to the Ashkenazi community, there were two Ḥevrei Kedusha, and families chose which rabbi performed the burial."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_99",
      "id": "fn1_99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" In Paraná, however, the provincial government had to intervene and create a “mixed” Ḥevra Kedusha to resolve internal issues between Sephardim and Ashkenazim (though the sources do not say exactly what the issues were)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_100",
      "id": "fn1_100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jewish cemeteries in provincial towns were also used by the smaller Jewish communities living close by who had not yet founded (and probably never would) their own cemeteries. The cemetery in Vera, province of Santa Fé, for example, was bought thanks to donations made by Jews living in various small nearby towns: Colonia Romang, Reconquista, Calchaquí, and Margarita."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_101",
      "id": "fn1_101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" The cemetery in Resistencia, Chaco, for example, buried people from the city of Corrientes, La Sabana, and Villa Angela."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_102",
      "id": "fn1_102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" In Chaco, those Jews who belonged to the Ḥesed VeEmet of Resistencia (which owned the cemetery) but lived in Presidencia Roque Sáenz Peña, rescinded their membership when the Jewish community of the small town founded their own cemetery."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_103",
      "id": "fn1_103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" Catamarca and Salta sent their Jewish dead to Tucumán (to the Dissidents’ Section of the municipal cemetery) until the local Jewish cemeteries opened."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_104",
      "id": "fn1_104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("CONCLUSION")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("These stories of conversations, agreements, and disagreements bring us to an important realization. Sephardi/Jewish identity, as reflected in the number of cemeteries and burial societies, was constructed as the result of particular events related to establishing new lives and how the living interacted among themselves. It has been assumed that the various Sephardi groups that arrived and settled in Argentina had an essential commonality derived from their expulsion from Spain, the maintenance of religious traditions born from their experience in Spain, and from their attachment to Spanish culture and Sephardi ritual."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_105",
      "id": "fn1_105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")]), _vm._v(" All these elements are understood to have constituted, throughout time, an “essential” Sephardi identity. Yet scholars, even as they describe how "), _c('i', [_vm._v("different")]), _vm._v(" these groups had become as a result of their wanderings in the various diasporic contexts after the expulsion from the Iberian Peninsula, still seem surprised when confronted with difference."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_106",
      "id": "fn1_106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" The few studies of the Sephardim in Argentina, for example, stress the lack of unity that characterized these groups."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_107",
      "id": "fn1_107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" Why, it is asked, did the various groups of Sephardim not become "), _c('i', [_vm._v("one?")]), _vm._v(" Why, in the case of Buenos Aires, did they create five cemeteries? Why did they insist on stressing their differences rather than focus on their similarities?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The only “constant” difference marked by all these cemetery walls was that of “Jewishness.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Notes#fn1_108",
      "id": "fn1_108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" Whether by religious conviction or cultural identification, (most) Jews requested to be buried in “Jewish” cemeteries, and Jewish communities responded to this wish by purchasing a space in which Jewish practices could be observed. The Jews who are buried inside the Jewish cemetery walls (no matter which Jewish organization owns it) mark, above all, this "), _c('i', [_vm._v("chosen")]), _vm._v(" difference with the rest of society. In Buenos Aires, for example, the need to maintain this difference moved Jews to acquire land rather than use the space provided by the city in the Dissidents’ Cemetery, and later in a section of the Chacarita plot. The same reason motivated the purchase of the Jewish cemeteries in the interior towns, like Santa Fé, Resistencia, and Vera.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The walls in Jewish cemeteries—and the existence of various Jewish cemeteries in one city or town—did not (and still do not) mark only “Jewishness” but also a desire to highlight origin. Although it is true "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("that for Argentine society that distinction may have been (and still may be) lost (Argentines probably read any Jewish cemetery’s wall as a basic differentiation between Jews and Catholics), it was a distinction that some Jewish communities wanted to maintain. In Buenos Aires, the different Sephardi groups each founded and fought for their own burial grounds; in some interior cities, the Ashkenazim preferred to have their own community cemetery; in other towns, internal walls divided Sephardi and Ashkenazi graves.")])]), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Difference did not override commonality. The (Ashkenazi) cemetery in Liniers, for example, was used by almost all Sephardi communities until they were able to buy their own grounds; Ashkenazim initially used the Sephardi cemeteries in Resistencia, Santa Fé, and Corrientes. Rather, the wish to preserve difference, or the lack of need to do so, speaks to boundaries that are constructed, arranged, and rearranged, and do not follow some “essential” characteristic of Jewishness or even “Sephardiness.” Each Jewish community in Argentine cities and towns decided on and constructed boundaries that differentiated and therefore constituted its own “Jewish” identity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cemetery walls were not built to divide only the dead. The boundaries constructed around the graves signified a much larger set of differences and commonalities. Because burial societies were part of a net of community “services,” which included medical, religious, and philanthropic activities, these walls also clearly marked difference among the living. In a sense, difference in origin translated (or not) into a set of groups, societies, and social organizations of which the cemetery was one. If Jews of different origins together founded social clubs, they also buried their dead together. If they socialized depending on origin, walls around cemeteries also were put up. It is to the boundaries around the living that we now turn our attention.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d7321dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/12_Chapter01.vue
// module id = 90
// module chunks = 0